import {app} from '../../app';

app.service('ConfirmModal', modal);

/** @ngInject */
function modal($uibModal) {
    return ({cancelButtonTextKey, confirmButtonTextKey, messageKey, onConfirm, titleKey} = {}) =>
        $uibModal.open({
            component: 'spConfirm',
            resolve: {
                cancelButtonTextKey: () => cancelButtonTextKey,
                confirmButtonTextKey: () => confirmButtonTextKey,
                messageKey: () => messageKey,
                onConfirm: () => onConfirm,
                titleKey: () => titleKey,
            },
        }).result;
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-confirm/sp-confirm.modal.js